import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as mainStateSearchProduct from '../reducers';
import * as fromsubStateSearchProduct from '../reducers/search-product-solution.reducer';

export const selectSearchProductRequest = createSelector(
  mainStateSearchProduct.selectSearchProjectSolutionState,
  fromsubStateSearchProduct.selectSearchProductSolutions
);

export const selectSearchProductLoaded = createSelector(
  mainStateSearchProduct.selectSearchProjectSolutionState,
  fromsubStateSearchProduct.selectSearchProductSolutionsLoaded
);

export const selectSearchProductFailure = createSelector(
  mainStateSearchProduct.selectSearchProjectSolutionState,
  fromsubStateSearchProduct.selectSearchProductSolutionsError
);
